import React, { useState, useEffect, useRef } from "react";
import { Tabs, Tab } from "react-bootstrap";

import { Close } from "../../components/Icons";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/Loading";

import useAppContext, { actions } from "../../utils/Reducers";
import LeftMenuBar from "./MenuBar/LeftMenuBar";
import TopMenuBar from "./MenuBar/TopMenuBar";
import MainPage from "../../pages/MainPage";
import { useAxiosWithAuthorization } from "../../utils/api";
import ModalFactory from "react-modal-promise";
import { ToastContainer, toast, Slide } from "react-toastify";

import useWindowDimensions from "../../utils/validators";
import ham1 from "../../images/ham1.png";

import "../../lib/AuiGrid/AUIGrid_style.css";
import "../../styles/font/nanumsquare.css";
import "../../styles/font/noto.css";
import "antd/dist/antd.min.css";
import "@toast-ui/editor/dist/toastui-editor.css";
import "../../styles/css/main.css";
import "../../styles/css/sub1.css";
import "../../styles/css/sub2.css";
import "../../styles/css/font-ko.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import { createBrowserHistory } from "history";

const Layout = ({ children }) => {
  const dashBoard = "/Main";
  const fullscreen = "/Fullscreen";
  const {
    dispatch,
    store: {
      userInfo,
      previousMenuKey,
      menuKey,
      menuActionList,
      isAuthenticated,
      tabSize,
    },
  } = useAppContext();

  const cameraRef = useRef();

  let navigate = useNavigate(); //<-- this doesn't work!!!!

  //사용자메뉴정보 검색 URL
  const SERARCH_USER_MENU_URL = "/common/menu/searchUserMenuList.do";

  const [, fetchMenuList] = useAxiosWithAuthorization(
    {
      url: SERARCH_USER_MENU_URL,
    },
    { manual: true }
  );

  const [menuData, setMenuData] = useState(null);
  const getMenuList = async () => {
    const {
      data: { data },
    } = await fetchMenuList({
      params: {
        userId: userInfo.userId,
      },
    });

    dispatch(actions.setMenuList(data));
    dispatch(actions.setMenuOriginList(data));
    setMenuData(data);
  };

  useEffect(() => {
    getMenuList();

    dispatch(actions.setMenuKey(dashBoard));
    dispatch(actions.setTopMenuKey("0000000200"));
  }, []);

  const [key, setKey] = useState("bar");
  const [menuList, setMenuList] = useState([]);
  // ANCHOR: 메뉴 한개씩 닫기
  const handleTabCloseClick = (tabKey, event) => {
    if (tabKey === "0000000201") {
      cameraRef.current.onCameraClose();
    }

    event.stopPropagation();
    dispatch(
      actions.setMenuActionList(
        menuActionList
          .map((data) => data.menuId !== tabKey && data)
          .filter((data) => data !== false)
      )
    );

    const found = menuActionList.findIndex(
      (element) => element.menuId === menuKey
    );
    const found_prev = menuActionList.findIndex(
      (element) => element.menuId === previousMenuKey
    );
    //console.log(tabKey, menuKey, previousMenuKey);
    if (menuActionList && menuActionList.length - 1 > 0) {
      if (found >= 0) {
        // NOTE: 현재 Focusing된 page가 열려있다면 현상 유지
        if (tabKey === menuKey) {
          if (found_prev >= 0 && tabKey !== previousMenuKey) {
            dispatch(actions.setMenuKey(previousMenuKey));
          } else {
            dispatch(
              actions.setMenuKey(
                menuActionList[menuActionList.length - 2].menuId
              )
            );
          }
        } else {
          dispatch(actions.setMenuKey(menuKey));
        }
      } else {
        if (found_prev >= 0) {
          dispatch(actions.setMenuKey(previousMenuKey));
        } else {
          dispatch(
            actions.setMenuKey(menuActionList[menuActionList.length - 1].menuId)
          );
        }
      }
    } else {
      // NOTE: 모든 Tab이 닫혔을 경우 dashBoard로 이동
      dispatch(actions.setMenuKey(dashBoard));
    }
  };

  const handleTabOpenClick = (tabKey) => {
    //console.log(tabKey);
    const foundMenu = menuActionList.find(
      (element) => element.menuId === tabKey
    );
    // ANCHOR: 열려질 Tab
    // ANCHOR: 이전 Tab 기억

    dispatch(actions.setPreviousMenuKey(menuKey));
    dispatch(actions.setMenuKey(tabKey));
    if (foundMenu) {
      dispatch(actions.setTopMenuKey(foundMenu.rootMenuId));
    }
  };

  const ref = useRef(null);

  const { height, width } = useWindowDimensions();
  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    //console.log(ref?.current?.offsetWidth);
    dispatch(actions.setTabSize(ref?.current?.offsetWidth - 62));
  }, [height, width]);

  //_this : 적용시킬 element
  //_class : 적용시킬 class
  //_type : 선택 타입
  function menuTab(_this, _class) {
    selectClass(_this, _class);
    toggleClass("menuList", "favorite");
  }

  //_index : 인덱스
  //_contents : 콘텐츠 id
  //_this : 적용시킬 element
  //_class : 적용시킬 class

  function selectTab(_index, _contents, _this, _class, _type) {
    var mobileTab = document.getElementById("mMenuTabs");
    var pcTab = document.getElementById("pcMenuTabs");

    selectClass(_this, _class);
    //pc또는모바일도 같이 활성화한다.
    if (_type == "pc") {
      selectClass(mobileTab.children[_index], _class);
    } else {
      selectClass(pcTab.children[_index], _class);
    }

    var contents = document.getElementById(_contents);
    selectClass(contents.children[_index], _class);
  }

  //_this : 적용시킬 element
  //_class : 적용시킬 class
  //_toggle : 토글여부
  function selectClass(_this, _class, _toggle) {
    if (_toggle) {
      if (hasClass(_this, "on") === false) {
        addClass(_this, "on");
      } else {
        removeClass(_this, "on");
      }
    } else {
      if (hasClass(_this, "on") === false) {
        addClass(_this, "on");
      }
    }

    var sb = siblings(_this);
    for (var i = 0; i < sb.length; i++) {
      removeClass(sb[i], "on");
    }
  }

  //_target : 적용시킬 element
  //_class : 적용시킬 class
  function toggleClass(_target, _class) {
    var menu = document.getElementById(_target);
    if (hasClass(menu, _class)) {
      removeClass(menu, _class);
    } else {
      addClass(menu, _class);
    }

    //console.log(ref?.current?.offsetWidth);
    dispatch(actions.setTabSize(ref?.current?.offsetWidth - 62));
  }

  function addClass(element, className) {
    element.className += " " + className;
  }
  function removeClass(element, className) {
    var check = new RegExp("(\\s|^)" + className + "(\\s|$)");
    element.className = element.className.replace(check, " ").trim();
  }

  function hasClass(element, className) {
    if (element.className.indexOf(className) > -1) {
      return true;
    } else {
      return false;
    }
  }

  function siblings(element) {
    var children = element.parentElement.children;
    var tempArr = [];

    for (var i = 0; i < children.length; i++) {
      tempArr.push(children[i]);
    }

    return tempArr.filter(function (e) {
      return e != element;
    });
  }

  if (isAuthenticated) {
    return (
      <>
        <ModalFactory />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          transition={Slide}
        />
        {menuData && (
          <div className="screen" id="container">
            <LeftMenuBar />
            <div className="mainbox">
              <TopMenuBar />

              <div id="content" ref={ref}>
                <div className="box_greytap">
                  <div
                    className="ham"
                    onClick={(event) => toggleClass("container", "open")}
                  >
                    <img src={ham1} />
                  </div>
                  <Tabs
                    activeKey={menuKey}
                    onSelect={(k) => handleTabOpenClick(k)}
                    className="select_greytap"
                  >
                    <Tab
                      key={dashBoard}
                      eventKey={dashBoard}
                      title={"국내차량관리"}
                    >
                      <div style={{ paddingTop: "10px" }}>
                        <MainPage
                          menuInfo={menuData.find(
                            (element) => element.menuId === "0000000302"
                          )}
                        />
                      </div>
                    </Tab>
                    {menuActionList &&
                      menuActionList.map((menu) => {
                        const TabPage = menu.component;
                        const menuId = menu.menuId;
                        return (
                          <Tab
                            key={menuId}
                            eventKey={menuId}
                            title={
                              <span
                                style={{
                                  fontWeight: "bold",
                                }}
                              >
                                {menu.menuNmKor}
                                <span
                                  onClick={(event) =>
                                    handleTabCloseClick(menuId, event)
                                  }
                                  className="x"
                                >
                                  <Close />
                                </span>
                              </span>
                            }
                          >
                            <React.Suspense fallback={<Loading />}>
                              <TabPage
                                menuInfo={menu}
                                ref={menuId === "0000000201" ? cameraRef : null}
                              />
                            </React.Suspense>
                            <div children={children} />
                          </Tab>
                        );
                      })}
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  } else {
    const userAgent = window.navigator.userAgent;
    if (userAgent.indexOf("iPhone") > -1 || userAgent.indexOf("Android") > -1) {
      navigate("/mobile/login");
    } else {
      navigate("/login"); //<-- this doesn't work!!!!
    }
    return null;
  }
};

export default Layout;
